import * as React from 'react';
import { useField } from 'formik';
import MUIAutocomplete from '@mui/material/Autocomplete';
import MUITextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { AgentToolInfo } from '../hooks/useAgentTools';

interface Props {
  tools: AgentToolInfo[];
  helperText?: string;
}

export const AgentToolsField = ({tools, helperText}: Props) => {
  const [field, meta, helpers] = useField<string[]>('tools');
  const selected = tools.filter((tool) => (field.value ?? []).includes(tool.name));

  return (
    <MUIAutocomplete
      id="tools"
      multiple
      options={tools}
      value={selected}
      getOptionLabel={(tool) => tool.name}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      onChange={(_, value) => helpers.setValue(value.map((tool) => tool.name))}
      renderOption={(props, tool, {selected: isSelected}) => (
        <Box component="li" {...props} sx={{alignItems: 'flex-start !important'}}>
          <Checkbox sx={{mt: -0.5, mr: 1}} checked={isSelected}/>
          <ListItemText
            primary={
              <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <span>{tool.name}</span>
                {tool.requiresApproval
                  ? <Typography variant="caption" color="warning.main">⚠ needs approval</Typography>
                  : null}
              </Box>
            }
            secondary={tool.description}
          />
        </Box>
      )}
      renderInput={(params) =>
        <MUITextField {...params}
          name="tools"
          label="tools"
          error={!!meta.error}
          helperText={meta.error ?? helperText}
        />}
    />
  );
};
